// extracted by mini-css-extract-plugin
module.exports = {"footer-wrapper":"footer-wrapper-cf800677","footerWrapper":"footer-wrapper-cf800677","links-wrapper":"links-wrapper-39538c30","linksWrapper":"links-wrapper-39538c30"};